import React from "react";
import { useAuth } from "../../contexts/authContext/index.jsx";
import { useNavigate, Link } from 'react-router'

import { app } from '../../firebase/firebase.js';
import { getPremiumStatus } from "../stripe/subscriptionStatus.ts";
import { useEffect, useState } from "react";
import { auth } from "../../firebase/firebase.js";

export const AdminGaurd = ({ component: C }) => {
  const { userLoggedIn } = useAuth();

  const navigate = useNavigate()
  const [page, setPage] = useState(<div className="page-layout"></div>);

  useEffect(() => {

    auth.currentUser.getIdTokenResult()
    .then((idTokenResult) => {
      if (!!idTokenResult.claims.admin) {
        // Show admin UI.
        setPage(<C />);
      } else {
        // Show regular user UI.
        navigate('/')
      }
    })
  }, [app, auth.currentUser?.uid]);
  return (
    <>
      {page}
    </>
  )
};